var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.516,
    height: 21.048,
    viewBox: "0 0 20.516 21.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ef393b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.6 -2.399)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M60.571,45.481h.044a.611.611,0,0,0,.62-.576l.509-7.945a.621.621,0,0,0-1.24-.088L60,44.817A.607.607,0,0,0,60.571,45.481Z",
    transform: "translate(-43.912 -26.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M47.819,45.486a.619.619,0,0,0,.62-.62V36.921a.619.619,0,0,0-.62-.62.6.6,0,0,0-.62.62v7.945A.619.619,0,0,0,47.819,45.486Z",
    transform: "translate(-33.949 -26.399)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.324,45.557h.044a.622.622,0,0,0,.576-.664l-.509-7.924a.621.621,0,0,0-1.24.088L32.7,45a.608.608,0,0,0,.62.554Z",
    transform: "translate(-22.265 -26.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.209,5.542H17.433V3.329A.935.935,0,0,0,16.5,2.4H11.236a.935.935,0,0,0-.929.929V5.541H4.53a.929.929,0,0,0,0,1.859H5.592L6.655,21.278A2.361,2.361,0,0,0,9,23.447H18.7a2.362,2.362,0,0,0,2.346-2.169L22.125,7.4h1.063a.935.935,0,0,0,.929-.929.916.916,0,0,0-.908-.929ZM12.166,4.28h3.408V5.564H12.166Zm7.06,16.843a.508.508,0,0,1-.509.465H9.023a.507.507,0,0,1-.509-.465L7.451,7.4H20.265Z",
    transform: "translate(0 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.b819284476f99a23a5c5217b786a9d2a.svg";
export { ForwardRef as ReactComponent };